import { paginationStyles } from "@insite/content-library/Widgets/ProductList/ProductListPagination";
import { getMgbwPaginationOverrides } from "@tSurya/Common/Utilities/mgbwPaginationOverrides";

paginationStyles.pagination = getMgbwPaginationOverrides();
